// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"_025a50318d--dropdown--2b0Te"};